<footer class="footer">
  <div class="footer-content">
    <a routerLink="/" class="footer-logo-link">
      <img src="assets/images/PoweredByOsstre.png" alt="Form Rails Logo" class="footer-logo" />
    </a>
  </div>
</footer>

